import React, { useEffect, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { setPlanViewPosition } from '$root/store/actions';

import { Button, Menu, MenuItem } from '@blueprintjs/core';
import { Position } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import PosNE from '$root/graphics/pos-ne.svg';
import PosNW from '$root/graphics/pos-nw.svg';
import PosSE from '$root/graphics/pos-se.svg';
import PosSW from '$root/graphics/pos-sw.svg';
import { IconNames } from '@blueprintjs/icons';
import { Corner } from '$root/utils/enums';


export default function PlanViewPositionSelect(props)
{
    const planViewPosition = useSelector(state => state.ui.planView.position);
    const dispatch = useDispatch();

    const dispatchNewPos = (pos) => {
        dispatch(setPlanViewPosition(pos));
    }

    let popoverPos = Position.TOP_LEFT;
    let buttonIcon;

    switch (planViewPosition)
    {
    case Corner.SW:
        popoverPos = Position.TOP_RIGHT;
        buttonIcon = PosSW;
        break;
    case Corner.SE:
        popoverPos = Position.TOP_RIGHT;
        buttonIcon = PosSE;
        break;
    case Corner.NW:
        popoverPos = Position.BOTTOM_RIGHT;
        buttonIcon = PosNW;
        break;
    case Corner.NE:
        popoverPos = Position.BOTTOM_RIGHT;
        buttonIcon = PosNE;
        break;
    }


    return (
        <Popover2 minimal
                  position={popoverPos}
                  content={
                      <Menu>
                          {/*<MenuItem text={'North-East'}*/}
                          {/*          icon={<img src={PosNE} width={16} height={16} />}*/}
                          {/*          onClick={() => dispatchNewPos(Corner.NE)}*/}
                          {/*/>*/}
                          {/*<MenuItem text={'North-West'}*/}
                          {/*          icon={<img src={PosNW} width={16} height={16} />}*/}
                          {/*          onClick={() => dispatchNewPos(Corner.NW)}*/}
                          {/*/>*/}
                          <MenuItem text={'South-East'}
                                    icon={<img src={PosSE} width={16} height={16} />}
                                    onClick={() => dispatchNewPos(Corner.SE)}
                          />
                          <MenuItem text={'South-West'}
                                    icon={<img src={PosSW} width={16} height={16} />}
                                    onClick={() => dispatchNewPos(Corner.SW)}
                          />
                      </Menu>
                  }>
            <Button
                icon={<img src={buttonIcon} width={16} height={16} />}
                rightIcon={IconNames.DOUBLE_CARET_VERTICAL}
            />
        </Popover2>
    );
}